import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { AjaxErrors } from './model';
import { LoginView } from 'portcall/login/view';
import { noDefault } from 'lib/eventWrappers';

export let AjaxErrorsView = SuperCritical(({ model: m } : { model : AjaxErrors }) => {
    var err = m.Error();
    return (
        <div>
            {err && <div className="ajaxerrors">
                <div className="ajaxerrors-content alert alert-danger">
                    <div>
                        <span className="controls">
                            <a href="#" onClick={noDefault(err.ToggleDetails)}>Details</a>
                            <span className="pc-icon-bullet"></span>
                            <a href="#" onClick={noDefault(err.Remove)}><i className="glyphicon glyphicon-remove"></i></a>
                        </span>
                        <span className="message">
                            The server encountered an internal error performing your request (Status Code {err.StatusCode}).
                            Please re-load this page and retry your request. If this problem persists, please contact
                            {/* Force whitespace */' '}
                            <a href={m.SupportHref()}>Support</a>.
                        </span>
                    </div>
                    <ul className="error-properties" hidden={!err.ShowDetails()}>
                        <li>
                            <label>Server Message</label>
                            <span>{err.ServerMessage}</span>
                        </li>
                        <li>
                            <label>Server Stack Trace</label>
                            <span>{err.ServerStackTrace}</span>
                        </li>
                    </ul>
                </div>
            </div>}

            <LoginView modelContainer={m.Login} />
        </div>
    );
});


// WEBPACK FOOTER //
// ./apps/core/ajaxerrors/view.tsx